export function createBreadcrumbSchema({
  items = [],
  pageUrl = "",
}) {
  const validItems = items.filter(
    (item) =>
      item &&
      typeof item.name === "string" &&
      item.name.trim() !== "" &&
      typeof item.url === "string" &&
      item.url.trim() !== ""
  );

  const schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",

    itemListElement: validItems.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };

  if (pageUrl) {
    schema["@id"] = `${pageUrl}#breadcrumb`;
  }

  return schema;
}